import { ReactRouterConfig } from '@scfe-common/micro-frontend-utils';

const m = require.context('../../pages', true, /route\.(ts|tsx)$/);
const routeModules = m.keys().map(f => m(f).default) as ReactRouterConfig[];
export default routeModules;
